import {
    Sparkles,
    LayoutTemplate,
    DatabaseZap,
    Image,
    Eye,
    CheckCircle2
} from "lucide-react";

function getActiveIndex(status = "") {
    const normalized = String(status || "").toLowerCase();

    if (
        normalized.includes("generated") ||
        normalized.includes("published")
    ) {
        return 4;
    }

    if (
        normalized.includes("generating") ||
        normalized.includes("processing")
    ) {
        return 3;
    }

    if (
        normalized.includes("submitted") ||
        normalized.includes("queued") ||
        normalized.includes("pending")
    ) {
        return 2;
    }

    if (normalized.includes("preparing")) {
        return 1;
    }

    return 0;
}

export default function GeneratorLoadingCard({ status }) {
    const steps = [
        {
            title: "Understanding business",
            text: "Reading industry, audience, services, and website goal.",
            icon: Sparkles
        },
        {
            title: "Planning structure",
            text: "Choosing pages, layout flow, and industry-specific sections.",
            icon: LayoutTemplate
        },
        {
            title: "Preparing CRM modules",
            text: "Creating editable business data for your Nexus dashboard.",
            icon: DatabaseZap
        },
        {
            title: "Shaping visuals",
            text: "Planning hero, sections, images, and responsive preview.",
            icon: Image
        },
        {
            title: "Rendering preview",
            text: "Finalizing your website preview for review and publishing.",
            icon: Eye
        }
    ];

    const activeIndex = getActiveIndex(status);

    return (
        <div className="wg-loading-shell wg-loading-shell-premium">
            <div className="wg-loading-left">
                <div className="wg-loading-badge">
                    <Sparkles size={15} />
                    <span>AI Website Generation</span>
                </div>

                <h3 className="wg-loading-title">
                    Your website and CRM workspace are being prepared.
                </h3>

                <p className="wg-loading-subtitle">
                    Shriansh Nexus is creating a complete business-ready preview, not just a template.
                    This may take a few moments while AI prepares your content, layout, and CRM modules.
                </p>

                <div className="wg-loading-progress">
                    <div
                        className="wg-loading-progress-bar"
                        style={{
                            width: `${Math.max(18, ((activeIndex + 1) / steps.length) * 100)}%`
                        }}
                    />
                </div>

                <div className="wg-loading-status-row">
                    <span className="wg-loading-status-label">Current status</span>
                    <span className="wg-loading-status-value">{status || "Processing..."}</span>
                </div>
            </div>

            <div className="wg-loading-preview-skeleton" aria-hidden="true">
                <div className="wg-skeleton-browser">
                    <span />
                    <span />
                    <span />
                </div>

                <div className="wg-skeleton-hero">
                    <div>
                        <i />
                        <strong />
                        <p />
                        <em />
                    </div>
                    <section />
                </div>

                <div className="wg-skeleton-grid">
                    <span />
                    <span />
                    <span />
                </div>
            </div>

            <div className="wg-loading-steps">
                {steps.map((item, index) => {
                    const Icon = item.icon;
                    const completed = index < activeIndex;
                    const current = index === activeIndex;

                    return (
                        <div
                            className={`wg-loading-step ${completed ? "completed" : ""} ${current ? "current" : ""}`}
                            key={item.title}
                        >
                            <div className="wg-loading-step-dot">
                                {completed ? <CheckCircle2 size={15} /> : <Icon size={15} />}
                            </div>

                            <div className="wg-loading-step-copy">
                                <strong>{item.title}</strong>
                                <span>{item.text}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}